import Utils from "../../common/Utils";

export const EvaluationMark = ({criticality, onClick, noGreen=false}) => {
    const backgroundColor = Utils.calcSoundSigColor(criticality, noGreen);
    return (
        <div onClick={onClick} role="button" className="rounded-lg" style={{height: "17px", width: "17px", padding: "5px", backgroundColor: backgroundColor}}></div>
    )
}